<template>

    <div class="w-100 d-flex justify-content-start">
        <span class="h6 mb-0 pt-1 text-primary">
            € {{$root.currencyDisplaySimple(price)}}
        </span>
    </div>

</template>

<script>
export default {
    props: ['product'],
    data() {
        return {
            year: null,
            price: null,
        }
    },
    created() {

        this.product.combinations.sort(function(a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });

        this.price = this.product.combinations[0].price;

        for(let i=0; i<this.product.combinations[0].attributes.length; i++) {
            if(this.product.combinations[0].attributes[i].key == 'anno') {
                this.year = this.product.combinations[0].attributes[i].value_label;
            }
        }

    },
    mounted() {
    },
    methods: {
    },
    computed: {
    }
}
</script>
